module.exports = __webpack_public_path__ + "assets/img/Forest Walk.4aa1afc1.jpg";